export default __webpack_public_path__ + "static/media/banco-sudameris.8cb92f90.svg";